import { useEffect, useState } from 'react';
import type { AdminOrganizationDetail } from '../../../../domain/superadmin/types';
import { formatDateTime } from '../../../../utils/formatters';
import DashboardCard from '../../../dashboard/components/DashboardCard';
import { Button, Textarea } from '../../../../components/ui';

type NotesSectionProps = {
  note: AdminOrganizationDetail['note'];
  onSave?: (body: string) => void | Promise<void>;
  isSaving?: boolean;
};

export function NotesSection({ note, onSave, isSaving = false }: NotesSectionProps) {
  const [body, setBody] = useState(note?.body ?? '');

  useEffect(() => {
    setBody(note?.body ?? '');
  }, [note?.body]);

  const canSave = Boolean(onSave) && body.trim().length > 0 && body !== (note?.body ?? '');
  const readOnly = !onSave;

  return (
    <DashboardCard title="Notas internas" className="mb-s5">
      {note?.updatedAt && (
        <p className="mb-s3 text-[12px] text-muted">
          Última atualização:{' '}
          <span className="font-mono tabular-nums">{formatDateTime(note.updatedAt)}</span>
        </p>
      )}

      {readOnly && !note?.body ? (
        <p className="rounded-lg border border-dashed border-border bg-surface px-s4 py-6 text-center text-[13px] text-muted">
          Nenhuma nota interna registrada.
        </p>
      ) : (
        <div className="flex flex-col gap-s3">
          <Textarea
            label="Nota"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Registre contexto operacional visível apenas para superadmins…"
            minRows={4}
            readOnly={readOnly}
            disabled={isSaving}
          />
          {onSave && (
            <div className="flex justify-end">
              <Button
                type="button"
                size="sm"
                disabled={!canSave || isSaving}
                onClick={() => void onSave(body.trim())}
              >
                {isSaving ? 'Salvando…' : 'Salvar nota'}
              </Button>
            </div>
          )}
        </div>
      )}
    </DashboardCard>
  );
}
